require('angular').module('wowApp.common')
    .service('BazaarvoiceService', ['Restangular', require('./bazaarvoice-service')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/wowcommon/bazaarvoiceservice/index.js
 **/